import { render, staticRenderFns } from "./rechargePlatform.vue?vue&type=template&id=5a12711c&scoped=true&"
import script from "./rechargePlatform.vue?vue&type=script&lang=js&"
export * from "./rechargePlatform.vue?vue&type=script&lang=js&"
import style0 from "./rechargePlatform.vue?vue&type=style&index=0&id=5a12711c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12711c",
  null
  
)

export default component.exports